import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Alert, Stack, Typography } from "@mui/material";

import {
    DetailSection,
    FieldGrid,
    FieldItem,
    RelatedLink,
} from "components/detail";

export const BoardShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;

    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    게시판 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    게시판을 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        <FieldItem label="이름" value={record?.name} />
                        <FieldItem label="유형" value={record?.boardKind} />
                        <FieldItem label="수정일" value={record?.updatedDate} />
                        <FieldItem
                            label="관련 게시글 목록"
                            value={
                                <RelatedLink
                                    to={`/posts?filters[0][field]=boardId&filters[0][operator]=eq&filters[0][value]=${record?.id}`}
                                    label="바로가기"
                                />
                            }
                        />
                        <FieldItem
                            label="첨부이미지"
                            value={
                                <RelatedLink
                                    to={`/images?filters[0][field]=targetId&filters[0][operator]=eq&filters[0][value]=${record?.id}&filters[1][field]=category&filters[1][operator]=eq&filters[1][value]=BOARD`}
                                    label="바로가기"
                                />
                            }
                        />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
